// Textos "sueltos" de la landing que antes estaban hardcodeados. Ahora son secciones
// editables (tipo ficha: un objeto por sección) administrables desde incap-system.
// Estos valores son el FALLBACK y el seed inicial (= lo que hay hoy en el sitio).

export const homeAboutHeading = {
  subtitle: "",
  title: "Ventajas de estudiar con nosotros",
};

// Encabezado (opcional) de la banda de estadísticas de la portada.
export const awrapperHeading = {
  eyebrow: "",
  title: "",
  subtitle: "",
};

export const hero = {
  mode: "carousel",
  autoplay: false,
  intervalMs: 6500,
  defaultOverlay: "Oscuro",
  welcome: "Bienvenido a",
  title: "INSTITUTO DE CAPACITACIÓN Y APRENDIZAJE PERMANENTE",
  subtitle: "Te acompañamos para que logres más.",
  ctaText: "CONTÁCTANOS",
  ctaLink: "/contacto",
  aulaText: "Ingresa al Aula virtual",
  aulaLink: "https://aula-virtual.incap.edu.mx/auth/sign-in",
  slides: [
    {
      id: "hero-original",
      enabled: true,
      type: "General",
      eyebrow: "Bienvenido a INCAP",
      title: "Educación que trabaja contigo",
      subtitle: "Estudia con acompañamiento cercano, horarios flexibles y programas pensados para avanzar.",
      badge: "Modalidades flexibles",
      dateText: "",
      primaryText: "CONTÁCTANOS",
      primaryLink: "/contacto",
      secondaryText: "Ingresa al Aula virtual",
      secondaryLink: "https://aula-virtual.incap.edu.mx/auth/sign-in",
      imageDesktop: "main/bg.webp",
      imageMobile: "main/bg.webp",
      imageAlt: "Portada original INCAP",
      imageFitDesktop: "cover",
      imageFitMobile: "cover",
      imagePositionDesktop: "center center",
      imagePositionMobile: "center center",
      contentX: "Izquierda",
      contentY: "Centro",
      textAlign: "Izquierda",
      contentXMobile: "Izquierda",
      contentYMobile: "Abajo",
      textAlignMobile: "Izquierda",
      showContent: true,
      showContentMobile: true,
      overlayMobile: "Oscuro",
      overlay: "Oscuro",
    },
    {
      id: "hero-portada-facebook",
      enabled: true,
      type: "General",
      eyebrow: "",
      title: "",
      subtitle: "",
      badge: "",
      dateText: "",
      primaryText: "",
      primaryLink: "/contacto",
      secondaryText: "",
      secondaryLink: "",
      imageDesktop: "/img-portafa-fb.jpg",
      imageMobile: "/img-portafa-fb.jpg",
      imageAlt: "Portada institucional INCAP",
      imageFitDesktop: "contain",
      imageFitMobile: "contain",
      imagePositionDesktop: "center center",
      imagePositionMobile: "center center",
      contentX: "Izquierda",
      contentY: "Centro",
      textAlign: "Izquierda",
      showContent: false,
      showContentMobile: false,
      overlayMobile: "Ninguno",
      minHeightMobile: "340px",
      overlay: "Ninguno",
    },
    {
      id: "hero-nuevo-campus",
      enabled: true,
      type: "Próxima apertura",
      eyebrow: "Nuevo campus",
      title: "Inicio de clases en septiembre",
      subtitle: "Conoce nuestro nuevo espacio y asegura tu lugar para el siguiente ciclo.",
      badge: "Inscripciones abiertas",
      dateText: "Campus Benito Juárez 820-9",
      primaryText: "Solicitar informes",
      primaryLink: "/contacto",
      secondaryText: "Ver ubicación",
      secondaryLink: "/contacto",
      imageDesktop: "/nuevocampus.jpg",
      imageMobile: "/nuevocampus.jpg",
      imageAlt: "Nuevo campus INCAP",
      imageFitDesktop: "contain",
      imageFitMobile: "contain",
      imagePositionDesktop: "right center",
      imagePositionMobile: "center top",
      contentX: "Izquierda",
      contentY: "Centro",
      textAlign: "Izquierda",
      contentXMobile: "Izquierda",
      contentYMobile: "Abajo",
      textAlignMobile: "Centro",
      showContent: true,
      showContentMobile: false,
      overlayMobile: "Ninguno",
      minHeightMobile: "560px",
      overlay: "Oscuro",
    },
  ],
};

export const footer = {
  aboutTitle: "INCAP: Educación que trabaja contigo",
  aboutText:
    "<p>El Instituto de Capacitación y Aprendizaje Permanente —<strong>INCAP</strong>— nació en 2017 de una convicción simple pero poderosa: la educación tiene que servir para la vida real.</p><p>Somos una institución 100% mexicana, fundada por docentes con experiencia frente a grupo que identificaron un problema que muchos vivían en silencio: <strong>estudiar y trabajar al mismo tiempo no debería ser un sacrificio.</strong> Debería ser una ventaja.</p><p>Desde esa inquietud surgió un modelo educativo diseñado para combinar el aprendizaje en aula con las exigencias del entorno laboral, sin obligar al estudiante a elegir entre uno y otro. Porque entendemos que nuestros alumnos no llegan con el tiempo libre de una agenda vacía; llegan con responsabilidades, con metas, con una vida en movimiento.</p><p>Esa es la razón de ser de INCAP: <strong>acompañar a quienes no pueden detener su vida para seguir creciendo.</strong></p>",
  linksTitle: "Enlaces Útiles",
  links: [
    { text: "Términos de Servicio", link: "/contacto" },
    { text: "Aviso de Privacidad", link: "/aviso-de-privacidad" },
    { text: "FAQs", link: "/contacto" },
  ],
  contactTitle: "Contáctanos",
  email: "contacto@incap.edu.mx",
  phone: "(312) 339 85 73",
};

// Planteles/sedes físicas. Lista editable: se usa tanto en el Footer como en /contacto, así que
// agregar o quitar un plantel desde el panel se refleja en ambos lugares sin tocar código.
export const locations = [
  {
    id: "loc-jazmines",
    name: "Campus Jazmines",
    address: "Paseo de los Jazmines #303 L-4, Villa de Álvarez, Colima, México., C.P. 28984",
    phone: "(312) 339 85 73",
    mapEmbedUrl:
      "https://maps.google.com/maps?width=100%25&height=300&hl=es&q=P.%C2%BA%20de%20Jazmines%20303-L-4,%20Real%20Bugambilias,%2028984%20Cdad.%20de%20Villa%20de%20%C3%81lvarez,%20Col.+(incap)&t=&z=17&ie=UTF8&iwloc=B&output=embed",
  },
  {
    id: "loc-benito-juarez",
    name: "Campus Benito Juárez",
    address: "Av. Benito Juárez 820 interior 9, Villa de Álvarez, Colima",
    phone: "",
    mapEmbedUrl:
      "https://maps.google.com/maps?width=100%25&height=300&hl=es&q=Av.%20Benito%20Ju%C3%A1rez%20820%20interior%209%2C%20Villa%20de%20%C3%81lvarez%2C%20Colima+(incap)&t=&z=17&ie=UTF8&iwloc=B&output=embed",
  },
];

export const contact = {
  title: "Contáctanos",
  subtitle: "Déjanos tus dudas o comentarios.",
  email: "contacto@incap.edu.mx",
  phone: "(312) 339 85 73",
  facebookUrl: "https://www.facebook.com/incapcolima/",
  instagramUrl: "https://www.instagram.com/incapcolima?igsh=ZnhkajZldXJmM2E=",
  formTitle: "Escribenos tus dudas:",
};

export const bachillerato = {
  title: "Bachillerato",
  titleHighlight: "Presencial",
  titleTail: "o en línea",
  intro:
    "En la Prepa en Línea fortalecerás competencias que te servirán para trasladarte al nivel superior de estudios y para tener una inserción pronta y exitosa a escenarios laborales.",
  bullets: ["Inicia o continua estudios con nosotros.", "Duración de 24 meses.", "Mensualidades congeladas"],
  videoUrl: "https://www.youtube.com/embed/zCpkyN5mZkE",
  objective:
    "<p>Formar bachilleres con pensamiento crítico, bases académicas sólidas y capacidad de análisis, preparados para continuar estudios superiores o incorporarse a la vida productiva con responsabilidad y visión de futuro. El egresado del Bachillerato de INCAP será capaz de comprender y analizar fenómenos sociales, científicos y culturales desde una perspectiva reflexiva, comunicarse con claridad oral y escrita, y tomar decisiones informadas sobre su proyecto de vida académico y profesional.</p><p>Su formación integra el desarrollo de habilidades digitales, el pensamiento lógico-matemático, la comprensión lectora avanzada y el fortalecimiento de valores como la responsabilidad, la disciplina y el respeto a la diversidad.</p>",
  featuresTitle: "¿Por qué estudiar el Bachillerato en INCAP?",
  featuresText: [
    "El bachillerato no es solo un trámite hacia la universidad: es la etapa donde se construyen los hábitos y las bases que definirán tu desempeño académico futuro. Cursarlo en INCAP significa prepararte con seriedad, método y acompañamiento real.",
  ],
  admissionProfile:
    "<p>El aspirante debe contar con estudios de secundaria concluidos, así como disposición para el estudio autónomo y el compromiso con su formación académica. Se requieren habilidades básicas de comprensión lectora, razonamiento lógico-matemático y manejo elemental de tecnologías de la información. Es deseable que el aspirante tenga disciplina para organizar su tiempo de estudio y motivación genuina para concluir su formación de nivel medio superior.</p>",
  graduationProfile:
    "<p>El egresado del Bachillerato de INCAP será un estudiante con pensamiento crítico, competencias académicas sólidas en las áreas de humanidades, ciencias y matemáticas, y capacidad para continuar estudios de nivel superior con éxito.</p><p>Actuará con responsabilidad, disciplina y respeto a la diversidad, valores fundamentales para su desarrollo personal y profesional. Contará con las herramientas necesarias para tomar decisiones informadas sobre su trayectoria académica y para incorporarse, si así lo decide, al ámbito laboral con una base formativa sólida.</p>",
  validityTitle: "Validez y Reconocimiento:",
  sepClave: "06PBH0068T",
  rvoe: "SE-008-2019-EMS",
  rvoeLink: "https://drive.google.com/file/d/1UcTPYeXSg6_R3QgU6SgWDCJ2dfC6nWDv/view?usp=drive_link",
};
